export const MODES = ["mutirao", "treta"] as const;
export type Mode = (typeof MODES)[number];

/** Máximo de jogadores numa sala, em qualquer modo (F54). */
export const MAX_PLAYERS = 4;

/**
 * Jogadores por modo (F54): a Irmandade dá para jogar sozinho (1 a 4); a Arena precisa de um rival
 * (2 a 4), senão o único jogador "venceria" morrendo.
 */
export const PLAYER_LIMITS: Readonly<Record<Mode, { readonly min: number; readonly max: number }>> = {
  mutirao: { min: 1, max: MAX_PLAYERS },
  treta: { min: 2, max: MAX_PLAYERS },
};

/** "1 jogador", "3 jogadores". */
export function playersText(n: number): string {
  return `${n} ${n === 1 ? "jogador" : "jogadores"}`;
}

export const DIFFICULTIES = ["tranquilo", "arretado", "sinistro"] as const;
export type Difficulty = (typeof DIFFICULTIES)[number];

/** Nomes que o jogador vê (tema de fantasia, doc 08); os ids continuam internos. */
export const MODE_NAMES: Record<Mode, string> = { mutirao: "Irmandade", treta: "Arena" };
export const DIFFICULTY_NAMES: Record<Difficulty, string> = { tranquilo: "Escudeiro", arretado: "Cavaleiro", sinistro: "Heroico" };

const FATAL_PROTECTION: Record<Difficulty, number | undefined> = { tranquilo: 30, arretado: 60, sinistro: undefined };

/**
 * Recarga (s) da proteção contra golpe fatal, ou `undefined` se desligada (doc 07, J3):
 * Tranquilo 30 s, Arretado 60 s; desligada no Sinistro e na Treta.
 */
export function fatalProtectionCooldown(mode: Mode, difficulty: Difficulty): number | undefined {
  return mode === "treta" ? undefined : FATAL_PROTECTION[difficulty];
}
